<template>
  <div class="page-wrapper">
    <div class="container-fluid h-100">
      <div class="row h-100">
        <div class="col-2 h-100 vertical-scroll" >

          <table class="table text-left" style="margin-bottom: 100px;">
            <tbody>
            <tr v-for="m in vendors" class="hover-item" v-on:click="openItem(m.id)" v-bind:class="{'row-item-selected': item != false && m.id ==item.id}">
              <td>{{m.title}}</td>
<!--              <td>{{}}</td>-->
<!--              <td>{{}}</td>-->
            </tr>
            </tbody>
          </table>
          <div style="width: 100%; height: 100px; min-height: 100px;"></div>
        </div>
        <div class="col-4 h-100 vertical-scroll">
          <div class="card" v-if="item != false" style="margin-top:20px;">
            <div class="card-header text-left">
              <strong>{{item.title}}</strong>

              <span style="float:right;" v-on:click="editVendor(item)"><i class="fas fa-edit"></i> EDIT</span>
              <!--                        <button class="btn btn-primary" style="float:right" v-on:click="saveItem"><i class="fas fa-save"></i> Save</button>-->
              <!--                <span><i class="fas fa-trash"></i></span>-->
              <!--                        <button class="btn btn-primary" style="float:right"  v-if="editItem.edit == false" v-on:click="toggleEdit"><i class="fas fa-edit"></i> Edit</button>-->
              <br>
              {{item.address}}<br> {{editItem.postCode}}
              <br>
              {{item.contact}}
              <br>
              Available to Shops: <span v-if="item.canOrder == true"><i class="fas fa-check-circle checked-green"></i></span><span v-else><i class="fas fa-times"></i></span>
              <br>
              <template v-if="item.emails !== null && item.emails.length > 0">
                Emails: <span v-for="(e, i) in item.emails">{{e}} </span>
              </template>
              <template v-else><span style="color:red;">Email required to place order</span></template>
              <br>
              <template v-if="item.ccEmails !== null && item.ccEmails.length > 0">
                CC Emails: <span v-for="(e, i) in item.ccEmails">{{e}} </span>
              </template>
            </div>
            <div class="card-body">
              <div class="container info-panel" v-if="item != false">

                <div class="row text-left">
                  <div class="col-12">


                  </div>
                </div>

                <div class="row" v-if="item.id > 0 && item.type === 'vendor' && item.products != undefined">
                  <div class="col-12 section-header">
                    Product List
                  </div>
                </div>
                <div class="row" v-if="item.type === 'vendor'">
<!--                  <div class="col-12">-->
                    <table class="table">
                      <tr>
<!--                        <th>ID</th>-->
                        <th class="text-left">Title</th>
                        <th>Type</th>
                        <th>Stock</th>
                        <th>Min Stock</th>
<!--                        <th></th>-->
                      </tr>
                      <tbody>
                      <tr v-for="product in item.products">
<!--                        <td>{{product.id}}</td>-->
                        <td class="text-left">{{product.title}}</td>
                        <td>{{product.stockType}}</td>
                        <td><span v-if="product.stockType === 'stock'">{{product.currentStock}}</span></td>
                        <td><span v-if="product.stockType === 'stock'">{{product.minStock}}</span></td>
<!--                        <td><span v-on:click="addOrderItem(product)"><i class="fas fa-plus"></i></span></td>-->
                      </tr>
                      </tbody>
                    </table>
<!--                  </div>-->
                </div>




              </div>
            </div>
          </div>

        </div>
        <div class="col-6 h-100" style="overflow-y: scroll">
          <div class="card" style="margin-top:20px;"  v-if="item.id > 0 && item.type === 'vendor'">
            <div class="card-header text-left">

              <button class="btn btn-success" @click="getUnsentOrderList">Pending Orders</button>
              <date-picker v-model="dateRange" style="margin-left: 20px;" valueType="format" @change="dateRangeSelected" range></date-picker>
              <button class="btn btn-success" @click="getVendorOrderList">Get</button>


              <span v-on:click="addOrder" style="float:right;"><i class="fas fa-plus-circle"></i> New Order</span>
            </div>
            <div class="card-body">
              <div class="container">
                <div class="row">
                  <div class="col-12">
                    <table class="table">
                      <tr>

                        <th>PO</th>
                        <th>ID</th>
<!--                        <th>생성시간</th>-->

                        <th>주문전송</th>
                        <th>상태</th>

                        <th>Total</th>
                        <th>VAT</th>
                        <th>DUE</th>
                      </tr>
                      <tbody v-if="item.orders != null && item.orders.length > 0">
                      <tr v-for="order in item.orders" v-on:click="openOrderItem(order.id)">
                        <td>{{order.poNumber}}</td>
                        <td>{{order.id}}</td>
<!--                        <td>{{dateString(order.createdTimestamp)}}</td>-->
                        <td>{{dateString(order.orderSentTime)}}</td>
                        <td>{{orderStateString(order)}}</td>
                        <td>{{(order.totalPrice/100.0).toFixed(2)}}</td>
                        <td>{{(order.tax/100.0).toFixed(2)}}</td>
                        <td>{{(order.finalDue/100.0).toFixed(2)}}</td>
                      </tr>
                      </tbody>
                      <tbody v-else>
                      <tr>
                        <td colspan="7">No Pending Orders</td>
                      </tr>
                      </tbody>
<!--                      <tbody>-->
<!--                      <tr>-->
<!--                        <td colspan="7"><div class="new-order-btn" style="border: 1px dotted grey; padding: 20px;" v-on:click="addOrder"><i class="fas fa-plus-circle"></i> New Order</div></td>-->
<!--                      </tr>-->
<!--                      </tbody>-->
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>



        </div>
      </div>
    </div>
    <div class="floating-button" style="bottom: 20px; left: 20px;" v-on:click="createNewMerchant" v-if="editItem == false || editItem.id > 0">
      <i class="fas fa-plus"></i>
    </div>
    <div class="floating-button" style="bottom: 20px; left: 100px;" v-on:click="downloadVendorList" v-if="editItem == false || editItem.id > 0">
      <i class="fas fa-download"></i>
    </div>
    <input type="file" ref="file" style="display: none;" v-on:change="excelFilePickedUp"/>
    <div class="floating-button" style="bottom: 20px; left: 180px;" v-on:click="onFileSelectorClick" v-if="editItem == false || editItem.id > 0">

      <i class="fas fa-upload"></i>
    </div>

    <div class="manual-button" style="bottom: 20px; right: 40px; background: #000;" v-on:click="openManual">
      <i class="fas fa-question-circle"></i>
    </div>

    <transition name="slide">
      <div class="item-container" v-if="order != false" v-on:click="closeOrder">
        <div class="card" v-if="order != false" style="margin-top:50px; height: calc(100% - 100px);" v-on:click.stop="dummy">
          <div class="card-header text-left" style="font-size: 1.4rem; background-color: #7391FF; color:white;">
            <div style="width: 100%; display: flex;">
              <div style="width: 50%;">
                <div v-if="order.poNumber !== null && order.poNumber.length > 0">
                  <strong>PO # {{order.poNumber}}</strong>
                </div>
                <div v-else>
                  <strong>ID # {{order.id}}</strong>
                </div>
              </div>
              <div style="width: 50%; text-align: right;">
                <span v-on:click.stop="closeOrder"><i class="fas fa-times"></i></span>
              </div>
            </div>

          </div>
          <div class="card-body">
            <div style="text-align: left; padding:10px;">
              PO Number: <input v-model="order.poNumber" @change="updateOrder"/>
            </div>
            <div style="text-align: left; padding:10px;">
              Delivery Date : <input type="date" v-model="order.deliveryDate" v-on:change="updateOrder"/>
            </div>

            <table class="table">
              <tr>
                <th class="text-left">Item</th>
                <th>Unit Price</th>
                <th></th>
                <th>Qty</th>

                <th></th>
                <th></th>
                <th>Total Price</th>
                <th>VAT</th>
                <th></th>
              </tr>
              <tbody v-if="order.list != undefined && order.list != null && order.list.length > 0">
              <tr v-for="(item, ii) in order.list">
                <td class="text-left">{{item.title}}</td>
                <td><input v-if="order.state >= 0 && order.state < 100" v-model="item.price" v-on:change="updateOrder"/><span v-else>{{(item.price).toFixed(2)}}</span></td>
                <td><span v-if="order.state < 100" v-on:click="changeVendorOrderItemAmount(ii,1)"><i class="fas fa-plus-circle"></i></span></td>
                <td><input type="number" style="width: 50px; text-align: center;" v-model="item.amount" @change="amountEntered(ii)" :disabled="order.state >= 100"/></td>
                <td><span v-if="order.state < 100" v-on:click="changeVendorOrderItemAmount(ii,-1)"><i class="fas fa-minus-circle"></i></span></td>
                <td>
                  <select v-if="item.amount < 0" v-model="item.stockType" :disabled="order.state >= 100">
                    <option value="disposal">Disposal</option>
                    <option value="return_to_vendor">Return</option>
                  </select>
                </td>
                <td>{{(item.totalPrice/100).toFixed(2)}}</td>
                <td>{{(item.tax/100).toFixed(2)}} ({{(item.taxRate/100).toFixed(0)}}%)</td>
                <td><span v-on:click="deleteOrderItem(item)"><i class="fas fa-trash"></i></span></td>
              </tr>
              </tbody>
              <tbody>
              <tr v-if="order.state >= 0 && order.state < 100">
                <td class="text-left">
                  <select class="form-control" v-model="selectedProduct">
                    <option value="0">Select Product</option>
                    <option v-for="p in item.products" v-if="p.parentId==0" :value="p.id">{{p.title}}</option>
                  </select>
                  <input class="form-control" v-model="productSearchWord"/>

                  <div style="width:100%" v-if="productSearchWord.length >= 3">
                    <ul class="list-group">
                      <li class="list-group-item" v-for="p in item.products" v-if="productSearchWord.length >= 3 && p.title.toLowerCase().includes(productSearchWord.toLowerCase()) == true" v-on:click="addNewOrderFromList(p)">{{p.title}}</li>
                    </ul>
                  </div>

                  <div style="width:100%; margin-top: 20px;">
                    Search from all products
                    <input type="text" v-model="searchWord" id="order-product-candidate-search-input" v-on:keyup="search" style="width: calc(100% - 50px)" placeholder="Search Product"/>
                    <span style="height: 30px; line-height: 30px; padding-left:10px;" v-on:click="initialiseSearch"><i class="fas fa-times"></i></span>
                  </div>
                  <ul class="autocomplete-results" v-if="candidates.length > 0">
                    <li class="autocomplete-result hover-item" v-for="(candidate, ci) in candidates" :tabindex="ci" :id="'order-product-candidate-'+ci" :key="'order-product-candidate-'+ci" v-on:keyup="moveFocusOnCandidate($event, candidate )" v-on:click.stop="selectCandidate(candidate)">
                      {{candidate.title}}
                    </li>
                  </ul>
                </td>
                <td>
                  <span v-on:click.stop="addNewOrderItem"><i class="fas fa-plus-circle"></i> Add</span>
                </td>
              </tr>
              </tbody>
              <tr>
                <th class="text-left">Total</th>
                <th></th>
                <th></th>
                <th>{{order.amount}}</th>
                <th></th>
                <th>{{(order.totalPrice/100).toFixed(2)}}</th>
                <th>{{(order.tax/100).toFixed(2)}}</th>
              </tr>

            </table>
            <div class="text-right" style="font-size: 2rem;">
              <strong>DUE: {{(order.finalDue/100).toFixed(2)}}</strong>
            </div>

            <div class="text-left">
              <h5>MEMO</h5>
              <template v-if="order.notes != null && order.notes.length > 0">
                <p v-for="(note, ni) in order.notes">#{{ni+1}} : {{note.description}}</p>
              </template>
              <input v-if="order != false && order.state < 10" class="form-control" v-model="order.note" placeholder="Enter MEMO" v-on:change="noteAdded"/>
            </div>
            <hr>
            <div class="text-right" style="font-size: 1.5rem;">
              <strong>상태: {{orderStateString(order)}}</strong>

            </div>
          </div>
          <div class="card-footer text-right">
            <button v-if="order != false && order.state < 100" class="btn btn-danger" style="float:left;" v-on:click="deleteOrder">Cancel</button>
            <button v-if="order != false" class="btn btn-dark" style="float:left;" v-on:click="closeOrder">Close</button>
            <button v-if="order.imageUrls != null && order.imageUrls.length > 0" v-on:click="openDoc(order)" class="btn btn-dark" style="float:right;">View Purchase Order</button>
            <button v-if="order != false && order.state < 10" v-on:click="placeOrder" class="btn btn-primary" style="float:right;">Place Order</button>
            <button v-if="order != false && order.state >= 0 && order.state < 100" v-on:click="completeOrder" class="btn btn-primary" style="float:right;">Complete Order</button>
            <br>

          </div>

        </div>

      </div>
    </transition>

    <transition name="slideup">
      <div class="item-container " v-if="editItem != false" style="padding-bottom: 100px;" v-on:click="closeEdit">
        <div class="card" style="margin-top: 10px; max-width:500px;" v-on:click.stop="dummy">
          <div class="card-header">
            <strong>Edit <span v-if="editItem.type === 'vendor'">Vendor</span><span v-else-if="editItem.type === 'supplier'">Supplier</span></strong>
          </div>
          <div class="card-body">
            <div class="container">
              <div class="row text-left form-row-container">
                <div class="col-12">
                  Title
                  <input type="text" class="form-control" v-model="editItem.title" placeholder="Title"/>
                </div>
                <div class="col-12">
                  Type
                  <select class="form-control" v-model="editItem.type">
                    <option value="">Select</option>
                    <option value="vendor">Vendor</option>
                    <option value="supplier">Supplier</option>
                  </select>
                </div>
                <div class="col-12">
                  Post Code
                  <input type="text" class="form-control" v-model="editItem.postCode" placeholder="POST CODE"/>
                </div>
                <div class="col-12">
                  Address
                  <input type="text" class="form-control" v-model="editItem.address" placeholder="Address"/>
                </div>
                <div class="col-12">
                  Contact
                  <input type="text" class="form-control" v-model="editItem.contact" placeholder="Contact"/>
                </div>
                <div class="col-12">
                  Shop Can Order to This Vendor
                  <div class="form-control select-div" v-bind:class="{'select-positive': editItem.canOrder==true}" v-on:click="editItem.canOrder = !editItem.canOrder">
                    <span ><i class="fas fa-check unchecked" v-bind:class="{'fa-check-circle checked-green':editItem.canOrder==true}"></i></span>
                    <span v-if="editItem.canOrder==true"><strong>YES</strong> (Shop can see this vendor)</span>
                    <span v-else><strong>NO</strong> (Shop CANOT see this vendor)</span>
                  </div>

                </div>
                <div class="col-12">
                  <label>Emails</label>
                  <input-tag type="text" :limit="100" v-model="editItem.emails" placeholder="Emails max 45"/>
                </div>
                <div class="col-12">
                  <label>CC Emails</label>
                  <input-tag type="text" :limit="100" v-model="editItem.ccEmails" placeholder="CC Emails max 45"/>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="container">
              <div class="row">
                <div class="col-4"><button class="btn btn-dark" style="float:left;" v-on:click="closeEdit"><i class="fas fa-times"></i> Cancel</button></div>
                <div class="col-4"><button class="btn btn-danger" v-on:click="askDeleteItem(editItem)"><i class="fas fa-trash"></i> Delete</button></div>
                <div class="col-4"><button class="btn btn-primary" style="float:right" v-on:click="saveItem"><i class="fas fa-save"></i> UPDATE</button></div>
              </div>
            </div>


          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>

  import {
    completeVendorOrder,
    createNewVendor,
    createNewVendorOrder, createNewVendorOrderItem, deleteVendor, deleteVendorOrder,
    getVendor,
    getVendorOrder, getVendorOrders, getVendorReport,
    getVendors, sendVendorOrder,
    updateVendor, updateVendorBulk, updateVendorOrder, vendorOrderStatusString
  } from "../api/vendors";
  import {getVendorProducts, searchAllProducts, searchProducts} from "../api/product";
  import {millisToDate, millisToReadable, setLastPage, showDialog} from "../api/utils";
  import InputTag from 'vue-input-tag'
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';
  export default {
        name: "Suppliers",
      data() {
          return {
            vendors:[],
            item:false,
            editItem:false,
            order:false,
            selectedProduct:0,
            type:'',
            state: {
              tickets: [{name: "test"}],
              headers: ["Test header"]
            },
            productSearchWord: '',
            dateRange:'',
            searchWord:'',
            candidates:[],
          }
      },
      components: {
        InputTag,
        DatePicker,
      },
      created() {
        setLastPage(this.$route.path);
          if(localStorage.getItem("vendor-kokoro-order-date-from") != null && localStorage.getItem("vendor-order-date-to") != null) {
            this.$data.dateRange = [localStorage.getItem("vendor-kokoro-order-date-from"), localStorage.getItem("vendor-order-date-to")];
          } else {
            this.$data.dateRange = null;
          }
      },
      mounted() {
          this.updateView();
      },
      updated() {
          console.log("UPDATED");
      },
      watch: {
          $route(to, from) {
              console.log("Route changed")
              this.updateView()
          }
      },
      beforeDestroy() {
      },
      methods: {
        orderStateString: vendorOrderStatusString,
        timeString:millisToReadable,
        dateString: function(time) {
          return millisToDate(time, '-');
        },
        initialiseSearch: function() {
          this.$data.searchWord = '';
          this.$data.candidates = [];
        },
        dateRangeSelected: function() {
          console.log("dateRangeSelected")
          console.log(this.$data.dateRange)

          if(this.$data.dateRange.length !== 2) {
            return;
          }

          if(this.$data.dateRange[0] > this.$data.dateRange[1]) {
            let temp = this.$data.dateRange[1];
            this.$data.dateRange[0] = this.$data.dateRange[1];
            this.$data.dateRange[1] = temp;
          }

        },
        updateView: function() {
          let self = this;
          console.log("Get Merchant List")
          self.$data.vendors = [];
          if(this.$route.query.type !== undefined) {
            console.log("Qeury = " + this.$route.query.type)
            this.$data.type = this.$route.query.type;
          } else {
            this.$data.type = 'vendor';
          }
          this.closeVendor();
          getVendors(this.$data.type)
            .then(function(data) {
              if(data.success == true) {
                self.$data.vendors = data.item;
              }
            })
            .catch(function(err) {
              console.log(err);
            })
        },
        createNewMerchant: function() {
          this.closeVendor();
          this.$data.editItem = createNewVendor();
          this.$data.editItem.type = this.$data.type;
        },
        askDeleteItem: function(item) {
          let self = this;
          this.$modal.show('dialog', {
            title:'',
            text: item.title + " 삭제 하시겠습니까?",
            buttons:[
              {
                title:'아니오',
                handler:()=>{
                  self.$modal.hide('dialog');
                }
              },
              {
                title:'삭제하기',
                handler:()=>{
                  self.$modal.hide('dialog');
                  self.deleteItem(item);
                }
              }
            ]
          })
        },
        deleteItem:function(item) {
          let self = this;
          deleteVendor(item.id)
          .then(function(data) {
            if(data.success == true) {
              if(self.$data.editItem.id == data.item.id) {
                self.$data.editItem = false;
              }
              if(self.$data.item.id == data.item.id) {
                self.$data.item = false;
              }
              for(let i = 0 ; i < self.$data.vendors.length ; i++) {
                if(self.$data.vendors[i].id == data.item.id) {
                  self.$data.vendors.splice(i, 1);
                  return;
                }
              }
            } else {
              showDialog(data.message);
            }
          })
          .catch(function(err) {
            let msg = err;
            if(err.response != undefined) {
              msg += ' (' + err.response + ')';
            }
            showDialog(msg, "ERROR");
          })
        },
        saveItem: function() {
          let self = this;
          console.log("save merchant item");
          console.log(this.$data.editItem);
          updateVendor(this.$data.editItem)
            .then(function(data) {
              if(data.success == true) {
                for(let i = 0 ; i < self.$data.vendors.length ; i++) {
                  if(self.$data.vendors[i].id == data.item.id) {
                    self.$data.vendors.splice(i, 1, data.item);
                    self.$data.editItem = false;
                    if(self.$data.item.id == data.item.id) {
                      self.openItem(self.$data.item.id);
                    }
                    return;
                  }
                }
                self.$data.vendors.push(data.item);
                self.$data.editItem = false;
              } else {
                console.log(data.message);
              }
            })
            .catch(function(err) {

            })
        },
        openItem: function(id) {
          this.closeVendor();
          let self = this;
          getVendor(id)
          .then(function(data) {
            if(data.success == true) {
              data.item.edit = false;
              data.item.products = [];
              self.$data.item = data.item;
              if(self.$data.item.type === 'vendor') {
                self.getVendorProducts();
              }
            }
          })
          .catch(function(err) {

          })

        },
        getUnsentOrderList: function() {
          if(this.$data.item === null || this.$data.item === false) {
            return;
          }

          this.$data.item.orders = [];
          let query = "vendorId=" + this.$data.item.id + "&merchantId=0&stateFrom=0&stateTo=0";

          let self = this;
          console.log()
          getVendorOrders(query)
            .then(function(data) {
              if(data.success == true) {
                data.item.sort(function(a, b) {
                  return b.orderSentTime - a.orderSentTime;
                })
                self.$data.item.orders = data.item;
              } else {
                showDialog(data.message);
              }
            })
            .catch(function(err) {
              let msg = err;
              if(err.response != undefined) {
                msg += ' (' + err.response + ')';
              }
              showDialog(msg, "ERROR");
            })
        },
        getVendorOrderList: function() {
          if(this.$data.item === null || this.$data.item === false) {
            return;
          }

          if(this.$data.dateRange === null) {
            showDialog("Please select date range");
            return;
          }
          if(this.$data.dateRange.length !== 2) {
            showDialog("Please select date range");
            return;
          }

          this.$data.item.orders = [];
          localStorage.setItem("vendor-kokoro-order-date-from", this.$data.dateRange[0]);
          localStorage.setItem("vendor-kokoro-order-date-to", this.$data.dateRange[1]);
          let start = new Date(this.$data.dateRange[0]);
          start.setHours(0,0,0,0);
          let end = new Date(this.$data.dateRange[1]);
          end.setHours(23,59,59,999);
          let query = "vendorId=" + this.$data.item.id + "&merchantId=0&sentFrom=" + start.getTime() + "&sentTo=" + end.getTime();
          query += "&stateFrom=0&stateTo=100";
          let self = this;
          console.log()
          getVendorOrders(query)
          .then(function(data) {
            if(data.success == true) {
              data.item.sort(function(a, b) {
                return b.orderSentTime - a.orderSentTime;
              })
              self.$data.item.orders = data.item;
            } else {
              showDialog(data.message);
            }
          })
          .catch(function(err) {
            let msg = err;
            if(err.response != undefined) {
              msg += ' (' + err.response + ')';
            }
            showDialog(msg, "ERROR");
          })
        },
        getVendorProducts: function() {
          let self = this;
          let vendorId = this.$data.item.id;
          getVendorProducts(this.$data.item.id)
          .then(function(data) {
            if(vendorId == self.$data.item.id) {
              if (data.success) {

                self.$data.item.products = data.item;
              } else {

              }
            }
          })
        },
        closeVendor: function() {
          this.$data.order = false;
          this.$data.item = false;
        },
        openOrderItem: function(id) {
          let self = this;
          getVendorOrder(id)
          .then(function(data) {
            if(data.success == true) {
              for(let i = 0 ; i < data.item.list.length ; i++) {
                data.item.list[i].price = data.item.list[i].price/100.0;
              }
              self.$data.order = data.item;
            }
          })
          .catch(function(err) {

          })
        },
        editVendor: function(vendor) {
          this.$data.editItem = JSON.parse(JSON.stringify(vendor));
        },
        toggleBoolean: function(key) {
          this.$data.editItem[key] = !this.$data.editItem[key];
        },
        closeEdit: function() {
          if(this.$data.editItem != false) {
            this.$data.editItem = false;
          }
        },
        // getVendorProducts: function(vendorId) {
        //
        //   let self = this;
        //   getVendorProducts(vendorId)
        //   .then(function(data) {
        //     if(data.success == true) {
        //       self.$data.order = data.item;
        //     }
        //   })
        //   .catch(function(err) {
        //
        //   })
        // },
        addOrder: function() {
          if(this.$data.item.emails == null || this.$data.item.emails.length == 0) {
            showDialog("주문을 하기 위해서는 Vendor의 이메일주소가 설정되어야 합니다.");
            return;
          }
          let newOrder = createNewVendorOrder(this.$data.item.id);
          let self = this;
          updateVendorOrder(newOrder)
          .then(function(data) {
            console.log("new order added");
            console.log(data);
            if(data.success == true ) {
              if(self.$data.item.orders == null || self.$data.item.orders.length == 0) {
                self.$data.item.orders = [];
                self.$data.item.orders.push(data.item);
              } else {
                self.$data.item.orders.unshift(data.item)
              }

              self.$data.order = data.item;
            }

          })
        },
        addNewOrderFromList: function(p) {
          console.log("add new order item");
          if(this.$data.item == false) {
            this.$data.productSearchWord = '';
            return;
          }
          this.addOrderItem(p);
          this.$data.productSearchWord = '';
        },
        addNewOrderItem: function() {

          console.log("add new order item");
          if(this.$data.item == false) {
            return;
          }


          for(let i = 0 ; i < this.$data.item.products.length ; i++) {
            if(this.$data.item.products[i].id == this.$data.selectedProduct) {
              this.addOrderItem(this.$data.item.products[i]);
              this.$data.selectedProduct = 0;
              return;
            }
          }
          this.$data.selectedProduct = 0;
          showDialog("Cannot find product");
        },
        addOrderItem: function(product) {
          //check first if vendor id is correct
          // if(product.vendorId !== this.$data.order.vendorId) {
          //   this.$data.order = false;
          //   return;
          // }

          //Check if current order has the same item
          if(this.$data.order.list == undefined || this.$data.order.list == null) {
            this.$data.order.list = [];
          }

          if(this.$data.order.list.length > 0) {
            for(let i = 0 ; i < this.$data.order.list.length ; i++) {
              if(this.$data.order.list[i].productId == product.id) {
                this.$data.order.list[i].amount += 1;
                this.updateOrder();
                return;
              }
            }
          }

          let newItem = createNewVendorOrderItem(product);
          this.$data.order.list.push(newItem);
          this.updateOrder();
        },
        onVendorOrderItemAmountChanged: function() {
          this.updateOrder();
        },
        amountEntered: function(index) {
          console.log("amount entered [" + this.$data.order.list[index].amount + "]");
          console.log(this.$data.order.list[index].amount);
          if(this.$data.order.list[index].amount === '' || this.$data.order.list[index].amount.length == 0) {

            return;
          }

          console.log("calculate now");
          this.updateOrder();
        },
        changeVendorOrderItemAmount: function(index, diff) {
          this.$data.order.list[index].amount = Number(this.$data.order.list[index].amount)  + diff;
          this.updateOrder();
        },
        deleteOrderItem: function(item) {
          let self = this;
          this.$modal.show('dialog', {
            //title: '로그아웃',
            text: 'Are you sure to remove ' + item.title + '?',
            buttons: [
              {
                title: 'No',
                handler: () => {
                  self.$modal.hide('dialog');

                }
              },
              {
                title: 'Yes Remove',
                handler: () => {
                  self.$modal.hide('dialog');
                  self.deleteOrderItemConfirmed(item);
                }
              },

            ]

          });
        },
        deleteOrderItemConfirmed: function(item) {
          item.deleted = true;
          item.amount = 0;
          this.updateOrder();
        },
        deleteOrder: function() {
          let self = this;
          this.$modal.show('dialog', {
            //title: '로그아웃',
            text: 'Are you sure to delete PO ' + this.$data.order.id + '?',
            buttons: [
              {
                title: 'No',
                handler: () => {
                  self.$modal.hide('dialog');

                }
              },
              {
                title: 'Yes Remove',
                handler: () => {
                  self.$modal.hide('dialog');
                  self.deleteOrderConfirmed();
                }
              },

            ]

          });
        },
        deleteOrderConfirmed: function() {
          let self = this;
          deleteVendorOrder(this.$data.order.id)
          .then(function(data) {
            if(data.success == true) {
              for(let i = 0 ; i < self.$data.item.orders.length ; i++) {
                if(self.$data.item.orders[i].id == self.$data.order.id) {
                  self.$data.item.orders.splice(i, 1);
                  break;
                }
              }
              self.$data.order = false;
            } else {
              showDialog(data.message);
            }
          })
          .catch(function(err) {
            let msg = err;
            if(err.response != undefined) {
              msg += " (" + err.response + ')';
            }
            showDialog(msg, "ERROR");
          })
        },
        updateOrder: function() {
          let self = this;
          let totalPrice = 0;
          let amount = 0;
          let tax = 0;
          if(this.$data.order.list.length > 0) {
            for (let i = 0; i < this.$data.order.list.length; i++) {
              if(this.$data.order.list[i].deleted === true) {
                console.log(this.$data.order.list[i].title + " is deleted");
                continue;
              }
              this.$data.order.list[i].totalPrice = parseInt(this.$data.order.list[i].price*100) * Number(this.$data.order.list[i].amount);
              totalPrice += this.$data.order.list[i].totalPrice;
              amount += Number(this.$data.order.list[i].amount);
              this.$data.order.list[i].tax =  this.$data.order.list[i].totalPrice *  this.$data.order.list[i].taxRate / 10000;
              tax += this.$data.order.list[i].tax;
              this.$data.order.list[i].price = parseInt(this.$data.order.list[i].price*100);
            }
          }
          this.$data.order.totalPrice = totalPrice;
          this.$data.order.amount = amount;
          this.$data.order.tax = tax;
          this.$data.order.finalDue = totalPrice + tax;

          console.log(this.$data.order);
          updateVendorOrder(this.$data.order)
          .then(function(data) {
            if(data.success) {

              self.$data.order = data.item;
              for(let i = 0 ; i < self.$data.order.list.length ; i++) {
                self.$data.order.list[i].price = self.$data.order.list[i].price/100.0;
              }
              if(self.$data.item !== false) {
                if (self.$data.item.orders !== undefined && self.$data.item.orders !== null && self.$data.item.orders.length > 0) {
                  for (let i = 0; i < self.$data.item.orders.length; i++) {
                    if (self.$data.item.orders[i].id === data.item.id) {
                      self.$data.item.orders.splice(i, 1, data.item);
                      return;
                    }
                  }
                }
              }
            } else {
              showDialog(data.message);
            }
          })
          .catch(function(err) {
            let msg = err;
            if(err.response !== undefined) {
              msg += " (" + err.response +")";
            }
            console.log(err);
            showDialog(msg, "Error");
          })
        },
        placeOrder: function() {
          let self = this;
          sendVendorOrder(this.$data.order.id)
          .then(function(data) {
            if(data.success == true) {
              showDialog(data.message);
              self.openOrderItem(self.$data.order.id);
            } else {
              showDialog(data.message);
            }
          })
          .catch(function(err) {

          })
        },
        closeOrder: function() {
          console.log("close order view");
          this.$data.order = false;
        },
        noteAdded: function() {
          if(this.$data.order == false) {
            return;
          }
          if(this.$data.order.note != null && this.$data.order.note.length > 0) {
            let note = {
              id:0,
              vendorOrderId:this.$data.order.id,
              description:this.$data.order.note,
            }
            this.$data.order.notes.push(note);

          }
          this.$data.order.note = '';
          this.updateOrder();
        },
        completeOrder: function() {
          let self = this;
          for(let i = 0 ; i < this.$data.order.list.length ; i++) {
            if(this.$data.order.list[i].amount < 0 && this.$data.order.list[i].stockType !== 'disposal' && this.$data.order.list[i].stockType !== 'return_to_vendor') {
              showDialog(this.$data.order.list[i].title + "이 반품인데, stock type처리 방식을 설정해주세요. Disposal 또는 Return중 하나를 선택해주세요");

              return;
            }
          }
          if(this.$data.order.deliveryDate === '' || this.$data.order.deliveryDate === '0000-00-00') {
            showDialog("Please Delivery Date to complete. Delivery date is required to set as stock in date for the items");
            return;
          }
          completeVendorOrder(this.$data.order.id)
            .then(function(data) {
              if(data.success == true) {
                showDialog("Purchase order completed and stocks applied to all products");
                self.$data.order = data.item;
                if(self.$data.editItem != false) {

                  self.openItem(self.$data.item.id);
                }
              } else {
                showDialog(data.message);
              }
            })
            .catch(function(err) {

            })
        },
        openDoc: function(order) {
          let url = 'https://storage.googleapis.com/kokoro-294123.appspot.com/' + order.imageUrls[0];
          console.log(url);
          window.open(url, '_blank');
        },
        dummy: function() {
          this.$data.productSearchWord = '';
        },
        downloadVendorList: function() {

          const FileDownload = require('js-file-download');
          getVendorReport(this.$data.type)
          .then(function(response) {
            FileDownload(response.data, "Kokoro-Vendor-List-report.xlsx");
          })
          .catch(function(err) {
            console.log("report error " + err);
            if(err.response != undefined) {
              console.log(err.response);
            }
          })
        },
        uploadVendorList: function(list) {
          if(list.length == 0) {
            return;
          }
          let self = this;
          updateVendorBulk(list)
          .then(function(data) {
            if(data.success == true) {
              self.$data.vendors = [];
              self.updateView();
            }
          })
        },
        onFileSelectorClick: function() {
          console.log("upload clicked");
          this.$refs.file.value = "";
          this.$refs.file.click();
        },
        excelFilePickedUp(e) {
          let self = this;
          if(e.target != undefined) {
            if (e.target.files != undefined) {
              console.log("PATH: " + e.target.files[0].name);
              let droppedFiles = e.target.files;

              ([...droppedFiles]).forEach(f => {
                if(f == undefined) {
                  return;
                }
                var reader = new FileReader(),
                  name = f.name;

                reader.onload = function (e) {
                  var results;
                  var data = e.target.result;


                  var fixedData = self.fixdata(data),
                    workbook = XLSX.read(btoa(fixedData), {type: 'base64'}),
                    firstSheetName = workbook.SheetNames[0],
                    worksheet = workbook.Sheets[firstSheetName];
                  self.$data.state.headers = self.get_header_row(worksheet);
                  results = XLSX.utils.sheet_to_json(worksheet, {range: 0, defval: ""});
                  console.log(results);
                  if(results.length < 3) {
                    window.alert("No Menu Data");
                    return;
                  }

                  let list = [];
                  for(let i = 0 ; i < results.length ; i++) {
                    let r = results[i];

                    if(r["Name"] === undefined || r["Name"] === "") {
                      continue;
                    }

                    let vendor = {
                      id:0,
                      title:r["Name"],
                      code:r["Code"],
                      contact:r["Contact"],
                      email:r["Email"],
                      emails:[],
                      ccEmails:[],
                      postCode:r["Post Code"],
                      address:r["Address"],
                      type:r["TYPE"],
                    }
                    console.log(r["Name"] + " " + r["TYPE"]);
                    if(r["ID"] !== '') {
                      vendor.id = r["ID"];
                    }
                    if(r["Emails"] !== undefined && r["Emails"].length > 0) {
                      vendor.emails = r["Emails"].split(",");
                    }
                    if(r["CC Emails"] !== undefined && r["CC Emails"].length > 0) {
                      vendor.ccEmails = r["CC Emails"].split(",");
                    }
                    list.push(vendor);



                  }

                  if(list.length > 0) {
                    self.uploadVendorList(list);
                  }
                }
                reader.readAsArrayBuffer(f);
              })


            }
          }
        },
        get_header_row: function (sheet) {
          var headers = [], range = XLSX.utils.decode_range(sheet['!ref']);
          //range.s.r = 2;//XLSX.utils.decode_row("3");
          var C, R = range.s.r; /* start in the first row */
          for (C = range.s.c; C <= range.e.c; ++C) { /* walk every column in the range */
            var cell = sheet[XLSX.utils.encode_cell({c: C, r: R})] /* find the cell in the first row */
            var hdr = "UNKNOWN " + C; // <-- replace with your desired default
            if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);
            headers.push(hdr);
          }
          return headers;
        },
        fixdata: function (data) {
          var o = "", l = 0, w = 10240;
          for (; l < data.byteLength / w; ++l) o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w, l * w + w)));
          o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
          return o;
        },
        openManual: function() {
          let url = "https://sites.google.com/boriumstudio.com/kokoro-erp-manual/vendorsupplier";
          window.open(url, '_blank');
        },
        search: function(e){

          if(e.key == 'ArrowDown') {
            console.log('ArrowDown');
            let firstCandidate = document.getElementById('order-product-candidate-0');
            if(firstCandidate != undefined && firstCandidate != null) {
              firstCandidate.focus();
            } else {
              console.log("cannot find ele");
            }
            return;
          }
          let self = this;
          this.$data.candidates = [];
          console.log("Search " + this.$data.searchWord);
          if(this.$data.searchWord == null || this.$data.searchWord.length < 3) {

            return;
          }


          searchAllProducts(this.$data.searchWord, 'active')
            .then(function(data) {
              console.log("search result ");
              console.log(data);
              if(data.success == true) {
                for(let i = 0 ; i < data.item.length ; i++) {
                  let already = false;
                  for(let j = 0 ; j < self.$data.item.products.length ; j++) {
                    if(data.item[i].id === self.$data.item.products[j].id) {
                      console.log("already duplicate");
                      already = true;
                      break;
                    }
                  }

                  if(already === false) {
                    self.$data.candidates.push(data.item[i]);
                  }
                }
                // self.$data.candidates =  data.item;
              } else {
                self.$data.candidates = [];
              }
            })
            .catch(function(err) {
              self.$data.candidates = [];
            })
          // return new Promise((resolve) => {
          //   if(input.length < 3) {
          //     resolve([]);
          //   }
          //   // self.searchProduct(encodeURI(input), resolve);
          //
          // })

        },
        moveFocusOnCandidate: function(e, c) {
          const activeEle = e.target;
          // const activeEleIndex = Array.prototype.indexOf.call(activeEle.parentElement, activeEle);
          console.log(e);
          console.log(c);
          // console.log("index " + activeEleIndex);
          console.log(e.key);
          if(e.key == "ArrowDown" && activeEle.nextElementSibling != null) {
            console.log("move down");
            activeEle.nextElementSibling.focus();
          }

          if(e.key == "ArrowUp")
            if(activeEle.previousElementSibling != null) {
              console.log("move up");
              activeEle.previousElementSibling.focus();
            } else {
              document.getElementById("order-product-candidate-search-input").focus();
            }

          if(e.key == 'Enter') {

            if(activeEle.nextElementSibling != null) {
              activeEle.nextElementSibling.focus();
            } else if(activeEle.previousElementSibling != null) {
              activeEle.previousElementSibling.focus();
            }
            this.addNewOrderFromList(c);
          }
        },
        selectCandidate: function(candidate) {
          this.addNewOrderFromList(candidate);
        }
      }
    }
</script>

<style scoped>
input {
  height: 35px;
  line-height: 35px;
  border-radius: 5px;
  border: 1px solid #b2b2b2;
}
</style>



// WEBPACK FOOTER //
// src/components/Suppliers.vue